/**
 * Search-related constants
 */

/** Search filter category identifiers */
export const SEARCH_FILTERS = {
  LINES: 'lines',
  FEATURES: 'features',
  MAX_WIN: 'max_win',
  PAYOUT: 'payout',
  JACKPOT: 'jackpot',
  CAMPAIGNS: 'campaigns',
} as const;

/** Features filter option identifiers */
export const SEARCH_FEATURES_OPTIONS = {
  BUY_BONUS: 'buy_bonus',
} as const;

/** Max Win filter option identifiers */
export const SEARCH_MAX_WIN_OPTIONS = {
  UP_TO_1200: 'lte_1200', // Games with max win up to x1200
  FROM_1200_TO_3000: '1200_3000', // Games with max win between x1200 and x3000
  FROM_3000_TO_8000: '3000_8000', // Games with max win between x3000 and x8000
  OVER_8000: 'gt_8000', // Games with max win over x8000
} as const;

/** Max Win boundary values */
export const SEARCH_MAX_WIN_BOUNDS = {
  UP_TO_1200: 1200,
  UP_TO_3000: 3000,
  UP_TO_8000: 8000,
} as const;

/** Jackpot filter option identifiers */
export const SEARCH_JACKPOT_OPTIONS = {
  PROGRESSIVE: 'progressive',
  PREMIUM_LINK: 'premium link',
} as const;

/** Campaign filter option identifiers */
export const SEARCH_CAMPAIGNS_OPTIONS = {
  TOURNAMENTS: 'tournaments',
  PRIZE_POP: 'prize_pop',
} as const;
